import { ProcessState } from './ProcessResponse';

export interface ProcessRequest {
  go_back: boolean;
  session_id: string;
  cycle_id?: string;
  language?: string;
  state?: ProcessState;
}
